import {
  getCSRF,
  UPDATE_SOFTWARE_LINKS_REQUEST,
  UPDATE_SOFTWARE_LINKS_SUCCESS,
  UPDATE_SOFTWARE_LINKS_ERROR
} from './global'

import axios from 'axios'

export const initialState = {
  usersList: [],
  user: {},
  scrollingBanner: null,
  orders: {
    list: [],
    pages: 0,
    last: false,
    currentPage: 0
  },
  history: {
    list: [],
    pages: 0,
    last: false,
    currentPage: 0
  },
  loading: false,
  errors: null
}

export const ADMIN_GET_USERS_LIST = 'ADMIN_GET_USERS_LIST'
export const ADMIN_GET_USERS_LIST_SUCCESS = 'ADMIN_GET_USERS_LIST_SUCCESS'
export const ADMIN_GET_USERS_LIST_ERROR = 'ADMIN_GET_USERS_LIST_ERROR'

export const ADMIN_GET_USER_DETAILS = 'ADMIN_GET_USER_DETAILS'
export const ADMIN_GET_USER_DETAILS_SUCCESS = 'ADMIN_GET_USER_DETAILS_SUCCESS'
export const ADMIN_GET_USER_DETAILS_ERROR = 'ADMIN_GET_USER_DETAILS_ERROR'

export const ADMIN_UPDATE_USER_ACCOUNT_SUCCESS = 'ADMIN_UPDATE_USER_ACCOUNT_SUCCESS'

export const ADMIN_GET_USER_ORDERS_SUCCESS = 'ADMIN_GET_USER_ORDERS_SUCCESS'

export const ADMIN_GET_LOGIN_HISTORY_REQUEST = 'ADMIN_GET_LOGIN_HISTORY_REQUEST'
export const ADMIN_GET_LOGIN_HISTORY_SUCCESS = 'ADMIN_GET_LOGIN_HISTORY_SUCCESS'
export const ADMIN_GET_LOGIN_HISTORY_ERROR = 'ADMIN_GET_LOGIN_HISTORY_ERROR'

export const ADMIN_UPDATE_USER_SUBSCRIPTIOS_REQUEST = 'ADMIN_UPDATE_USER_SUBSCRIPTIOS_REQUEST'
export const ADMIN_UPDATE_USER_SUBSCRIPTIOS_SUCCESS = 'ADMIN_UPDATE_USER_SUBSCRIPTIOS_SUCCESS'
export const ADMIN_UPDATE_USER_SUBSCRIPTIOS_ERROR = 'ADMIN_UPDATE_USER_SUBSCRIPTIOS_ERROR'

export const ADMIN_GET_SCROLLING_BANNER_REQUEST = 'ADMIN_GET_SCROLLING_BANNER_REQUEST'
export const ADMIN_GET_SCROLLING_BANNER_SUCCESS = 'ADMIN_GET_SCROLLING_BANNER_SUCCESS'
export const ADMIN_GET_SCROLLING_BANNER_ERROR = 'ADMIN_GET_SCROLLING_BANNER_ERROR'

export const ADMIN_UPDATE_SCROLLING_BANNER_REQUEST = 'ADMIN_UPDATE_SCROLLING_BANNER_REQUEST'
export const ADMIN_UPDATE_SCROLLING_BANNER_SUCCESS = 'ADMIN_UPDATE_SCROLLING_BANNER_SUCCESS'
export const ADMIN_UPDATE_SCROLLING_BANNER_ERROR = 'ADMIN_UPDATE_SCROLLING_BANNER_ERROR'

export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR'


export const getUsersList = params => (dispatch, getState, { httpRequest }) => {
  const { selected, pageSize, searchQuery } = params
  dispatch({ type: ADMIN_GET_USERS_LIST })
  return httpRequest.get(
    `/admin/get-users-list?page=${selected || 0}&pageSize=${pageSize || 5}&searchQuery=${searchQuery || ''}`
  )
    .then(response => dispatch(getUsersListSuccess(response.data, params.selected)))
    .catch(error => dispatch(getUsersListError(error.response)))
}

function getUsersListSuccess(usersList, currentPage) {
  usersList.rows.map(user => user.login_history = user.login_history.length)
  return {
    type: ADMIN_GET_USERS_LIST_SUCCESS,
    usersList,
    currentPage
  }
}

function getUsersListError(errors) {
  return {
    type: ADMIN_GET_USERS_LIST_ERROR,
    errors
  }
}

export const updateUserSubscriptions = ({ userId, ...params }) => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: ADMIN_UPDATE_USER_SUBSCRIPTIOS_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const response = await httpRequest.post(`/account/${userId}/subscriptions/update`, params, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch({ type: ADMIN_UPDATE_USER_SUBSCRIPTIOS_SUCCESS, user: response.data })
  } catch (err) {
    dispatch({ type: ADMIN_UPDATE_USER_SUBSCRIPTIOS_ERROR })
  }
}

export const getScrollingBanner = () => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: ADMIN_GET_SCROLLING_BANNER_REQUEST })
  return httpRequest.get('/scrolling-banner')
    .then(response => {
      dispatch({
        type: ADMIN_GET_SCROLLING_BANNER_SUCCESS,
        scrollingBanner: response.data
      })
    })
    .catch(error => {
      dispatch({
        type: ADMIN_GET_SCROLLING_BANNER_ERROR,
        error: error.response
      })
    })
}

export const updateScrollingBanner = params => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: ADMIN_UPDATE_SCROLLING_BANNER_REQUEST })
  try {
    const csrf = await dispatch(getCSRF())
    const response = await httpRequest.post('/scrolling-banner', params, {
      headers: {
        'x-csrf-token': csrf.token
      }
    })
    dispatch({
      type: ADMIN_UPDATE_SCROLLING_BANNER_SUCCESS,
      scrollingBanner: response.data
    })
  } catch (err) {
    dispatch({
      type: ADMIN_UPDATE_SCROLLING_BANNER_ERROR,
      error: err.response
    })
  }
}

export const getS3SingedUrl = params => async (dispatch, getState, { httpRequest }) => {
  const { fileName, fileType, secure } = params
  return httpRequest.get(`/sign-s3?fileName=${fileName}&fileType=${fileType}&secure=${secure}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}


export const uploadFile = params => async dispatch => {

  dispatch({ type: UPDATE_SOFTWARE_LINKS_REQUEST })

  var options = {
    onUploadProgress: event => params.onProgress(event),
    headers: {
      'Content-Type': params.file.type
    }
  }

  return axios.put(params.signedRequest, params.file, options)
    .then(response => {
      Promise.resolve(response)
    })
    .catch(err => Promise.reject(err))
}

export const updateFileInfo = params => async (dispatch, getState, { httpRequest }) => {
  dispatch({ type: UPDATE_SOFTWARE_LINKS_REQUEST })
  try {
    const response = await httpRequest.post('/update-file-info', params)
    dispatch({
      type: UPDATE_SOFTWARE_LINKS_SUCCESS,
      softwareLinks: response.data
    })
  } catch (err) {
    dispatch({
      type: UPDATE_SOFTWARE_LINKS_ERROR,
      error: err.response
    })
  }
}

const ACTION_HANDLERS = {
  [ADMIN_GET_USERS_LIST]: state => ({
    ...state,
    usersList: [],
    loading: true
  }),
  [ADMIN_GET_USERS_LIST_SUCCESS]: (state, { usersList, currentPage }) => ({
    ...state,
    usersList,
    currentPage: currentPage || 0,
    loading: false
  }),
  [ADMIN_GET_USERS_LIST_ERROR]: (state, { errors }) => ({
    ...state,
    usersList: [],
    errors,
    loading: false
  }),
  [ADMIN_GET_USER_DETAILS]: state => ({
    ...state,
    user: {}
  }),
  [ADMIN_GET_USER_DETAILS_SUCCESS]: (state, { user }) => ({
    ...state,
    user,
    loading: false
  }),
  [ADMIN_UPDATE_USER_ACCOUNT_SUCCESS]: (state, { user }) => ({
    ...state,
    user
  }),
  [ADMIN_GET_USER_ORDERS_SUCCESS]: (state, { orders }) => ({
    ...state,
    orders: {
      ...state.orders,
      pages: orders.count,
      list: orders.rows,
      last: orders.last
    }
  }),
  [ADMIN_GET_LOGIN_HISTORY_SUCCESS]: (state, { history }) => ({
    ...state,
    history: {
      ...state.history,
      list: history.rows,
      count: history.count,
      last: history.last,
      pages: history.pages,
    }
  }),
  [ADMIN_UPDATE_USER_SUBSCRIPTIOS_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [ADMIN_UPDATE_USER_SUBSCRIPTIOS_SUCCESS]: (state, { user }) => ({
    ...state,
    user,
    loading: false
  }),
  [ADMIN_UPDATE_USER_SUBSCRIPTIOS_ERROR]: state => ({
    ...state,
    loading: false
  }),
  [ADMIN_GET_SCROLLING_BANNER_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [ADMIN_GET_SCROLLING_BANNER_SUCCESS]: (state, { scrollingBanner }) => ({
    ...state,
    scrollingBanner,
    loading: false
  }),
  [ADMIN_UPDATE_SCROLLING_BANNER_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [ADMIN_UPDATE_SCROLLING_BANNER_SUCCESS]: (state, { scrollingBanner }) => ({
    ...state,
    scrollingBanner,
    loading: false
  }),
  [UPDATE_SOFTWARE_LINKS_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [UPDATE_SOFTWARE_LINKS_SUCCESS]: state => ({
    ...state,
    loading: false
  }),
  [UPDATE_SOFTWARE_LINKS_ERROR]: state => ({
    ...state,
    loading: false
  }),
  [UPLOAD_FILE_REQUEST]: state => ({
    ...state,
    loading: true
  }),
  [UPDATE_SOFTWARE_LINKS_SUCCESS]: state => ({
    ...state,
    loading: false
  }),
  [UPDATE_SOFTWARE_LINKS_ERROR]: state => ({
    ...state,
    loading: false
  })
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/admin.js